import React, { useEffect, useState } from "react";
import { Flex, Checkbox, Input, Select, InputNumber } from "antd";
import { useViewerStore } from "../../../../store/store";
import NotesTextArea from "../../../../components/Pure-UI-Components/Inputs/NotesTextArea";
import { BuildingDesignData } from "../../../../@types/types";

interface BuildingPropertiesProps {
  selectedBuilding: BuildingDesignData,
  setSelectedBuilding: React.Dispatch<React.SetStateAction<BuildingDesignData | undefined>>;
  readOnly: any,
}

const BuildingProperties: React.FC<BuildingPropertiesProps> = ({
  selectedBuilding,
  setSelectedBuilding,
  readOnly,
}) => {
  const masterDataList = useViewerStore.getState().masterDataList;
  const [aaoption, setAaoption] = useState<any>([]);
  const [nacoptions, setNacoptions] = useState<any>([]);
  const [lsoptions, setLsoptions] = useState<any>([]);

  const handeleAtticAccess = (value: number) => {
    let updateSelBuildingData = {
      ...selectedBuilding,
    };
    updateSelBuildingData.Attic_Access_Id = value;
    setSelectedBuilding(updateSelBuildingData);
  };

  const handleWhyAtticAccess = (value: number) => {
    let updateSelBuildingData = {
      ...selectedBuilding,
    };
    updateSelBuildingData.Why_No_Attic_Access_Id = value;
    setSelectedBuilding(updateSelBuildingData);
  };
  const handleAtticAccessNotes = (value: string) => {
    let updateSelBuildingData = {
      ...selectedBuilding,
    };
    updateSelBuildingData.Attic_Access_Notes = value;
    setSelectedBuilding(updateSelBuildingData);
  };

  const handleLayersShingles = (value: number) => {
    let updateSelBuildingData = {
      ...selectedBuilding,
    };
    updateSelBuildingData.Layers_of_Shingles_Id = value;
    setSelectedBuilding(updateSelBuildingData);
  };
  const handleAllRoofsTheSame = (value: boolean) => {
    let updateSelBuildingData = {
      ...selectedBuilding,
    };
    updateSelBuildingData.All_Roof_The_Same = value;
    setSelectedBuilding(updateSelBuildingData);
  };

  const handleNumberOfStories = (value: number) => {
    let updateSelBuildingData = {
      ...selectedBuilding,
    };
    updateSelBuildingData.Number_Of_Stories = value;
    setSelectedBuilding(updateSelBuildingData);
  };
  useEffect(() => {
    setAaoption(
      masterDataList?.AtticAccessList?.map((item, index_value) => {
        return {
          key: String(index_value + 1),
          label: item.label,
          value: Number(item.value),
        };
      })
    );
    setNacoptions(
      masterDataList?.NoAtticAccessReasons?.map((item, index_value) => {
        return {
          key: String(index_value + 1),
          label: item.label,
          value: Number(item.value),
        };
      })
    );
    setLsoptions(
      masterDataList?.LayersofShingles?.map((item, index_value) => {
        return {
          key: String(index_value + 1),
          label: item.label,
          value: Number(item.value),
        };
      })
    );
  }, [masterDataList]);

  return (
    <div id="buildingTab" className="tab__column obst-edit-mask tab_gap">
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div>
          <span className="tab__input--label small_input_label">
            Attic Access:
          </span>
        </div>
        <Select
          id="atticAccessSelect"
          options={aaoption}
          value={selectedBuilding.Attic_Access_Id}
          onChange={(value) => handeleAtticAccess(value)}
          className="small-input-feild"
          disabled={readOnly}
        />
      </Flex>
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div style={{ width: 95 }}>
          <span className="tab__input--label small_input_label">
            Why No Attic Access:
          </span>
        </div>
        <Select
          id="roofTypeSelect"
          options={nacoptions}
          value={selectedBuilding.Why_No_Attic_Access_Id}
          onChange={(value) => handleWhyAtticAccess(value)}
          className="small-input-feild"
          disabled={readOnly}
        />
      </Flex>
      <Flex
        justify="space-between"
        className="small_input_flex"
      >
        <div>
          <span className="tab__input--label small_input_label">
            Attic Access <br/>Notes:
          </span>
        </div>
        <NotesTextArea
          value={selectedBuilding.Attic_Access_Notes}
          onChange={(e: any) => handleAtticAccessNotes(e.target.value)}
          disabled={readOnly}
        />
      </Flex>
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div>
          <span className="tab__input--label small_input_label ">
            Layers of Shingles:
          </span>
        </div>

        <Select
          id="layersofShinglesSelect"
          options={lsoptions}
          value={selectedBuilding.Layers_of_Shingles_Id}
          onChange={(value) => handleLayersShingles(value)}
          className="small-input-feild"
          disabled={readOnly}
        />

      </Flex>
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div>
          <span className="tab__input--label small_input_label ">
            Number of Roofs:
          </span>
        </div>
        <Input
          id="inputNumberofRoofs"
          type="text"
          className="small-input-feild"
          value={
            selectedBuilding.Number_of_Roofs
              ? selectedBuilding.Number_of_Roofs
              : "No data found"
          }
          disabled={true}
        />
      </Flex>
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div>
          <span className="tab__input--label small_input_label ">
            Peak to Ground <br/>(In):
          </span>
        </div>
        <Input
          id="inputPeaktoGround"
          type="text"
          className="small-input-feild"
          value={
            selectedBuilding.Peak_to_Ground_Inches
              ? selectedBuilding.Peak_to_Ground_Inches
              : "No data found"
          }
          disabled={true}
        />
      </Flex>
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div>
          <span className="tab__input--label small_input_label ">
            Township:
          </span>
        </div>
        <Input.TextArea
          rows={ selectedBuilding?.Township?.length > 18 ? 2 : 1}
          className="small-input-feild small_text_area"
          value={
            selectedBuilding.Township
              ? selectedBuilding.Township
              : "No data found"
          }
          disabled={true}
          style={{ resize: "none" }}
        />
      </Flex>
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div>
          <span className="tab__input--label small_input_label ">
            All Roofs The Same?
          </span>
        </div>
        <Checkbox
          checked={selectedBuilding.All_Roof_The_Same ?? false}
          onChange={(e) => handleAllRoofsTheSame(e.target.checked)}
          value={selectedBuilding.All_Roof_The_Same}
          disabled={readOnly}
        />
      </Flex>
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div style={{ width: 95 }}>
          <span className="tab__input--label small_input_label">
            Special Requirements:
          </span>
        </div>

        <Input
          id="inputSpecialRequirements"
          type="text"
          className="small-input-feild"
          value={
            typeof selectedBuilding.Special_Requirements === 'string'
              ? selectedBuilding.Special_Requirements
              : ''
          }
          disabled={true}
        />
      </Flex>
      <Flex
        justify="space-between"
        className="small_input_flex"
      >
        <div style={{ width: 95 }}>
          <span className="tab__input--label small_input_label">
            Special Requirements Notes:
          </span>
        </div>

        <Input.TextArea
          rows={4}
          className="small_input_flex small_text_area small-input-feild"
          value={
            selectedBuilding.Special_Requirements_Notes
              ? selectedBuilding.Special_Requirements_Notes
              : "No data found"
          }
          disabled={true}
          style={{ resize: "none" }}
        />
      </Flex>
      <Flex align="center" justify="space-between" className="small_input_flex">
        <div>
          <span className="tab__input--label small_input_label ">
            Number of Stories:
          </span>
        </div>
        <InputNumber
          precision={0}
          className="small-input-feild"
          onChange={value => handleNumberOfStories(value ?? 0)}
          value={selectedBuilding.Number_Of_Stories}
        />
      </Flex>
    </div>
  );
};

export default BuildingProperties;
